import {
  DeesElement,
  property,
  html,
  customElement,
  TemplateResult,
  state,
  css,
  cssManager
} from '@designestate/dees-element';

import './lele-materialicon';

import * as domtools from '@designestate/dees-domtools';

import * as lointPubapi from '@losslessone_private/loint-pubapi';
import * as lelePubapiClient from '@losslessone_private/lele-pubapiclient';

type TItemToShow = 'products' | 'info';

declare global {
  interface HTMLElementTagNameMap {
    'lele-statusbar': LeleStatusbar;
  }
}

@customElement('lele-statusbar')
export class LeleStatusbar extends DeesElement {
  public static demo = () => html`<lele-statusbar></lele-statusbar>`;

  @property()
  public state: 'open' | 'closed' = 'closed';

  @property()
  public itemToShow: TItemToShow;

  @property()
  public logoUrl = `https://assetbroker.lossless.one/brandfiles/lossless/svg-minimal-bright.svg`;

  @property()
  public siteText = 'a premier source for knowledge';

  @property({ type: Array })
  public branches: lointPubapi.IRequest_Any_Pubapi_GetCompanyBranches['response']['branches'] = [];

  @property({ type: Array })
  public projects: lointPubapi.IRequest_Any_Pubapi_GetProjects['response']['projects'] = [];

  @property({ type: Boolean })
  public showButtons: boolean = false;

  pubapiClient = new lelePubapiClient.PubapiClient();

  constructor() {
    super();
    // you have access to all kinds of things through this.
    // this.setAttribute('gotIt','true');
  }

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          height: 40px;
          display: block;
          z-index: 100;
          position: relative;
          will-change: transform;
          user-select: none;
        }
        :host([hidden]) {
          display: none;
        }

        .maincontainer {
          --font-size: 20px;
          font-family: 'Roboto', sans-serif;
          background: ${this.goBright ? '#eeeeeb' : '#000000'};
          border-bottom: 1px solid ${this.goBright ? '#CCC' : '#444'};
          color: ${this.goBright ? '#333' : '#BBB'};
        }

        .maincontent {
          height: 40px;
          font-size: var(--font-size);
          line-height: var(--font-size);
          padding: 10px 0px 8px 0px;
          display: grid;
          grid-template-columns: calc(100% / 3) calc(100% / 3) calc(100% / 3);
          max-width: var(--lelecv-pagewidth, 1200px);
          margin: auto;
        }
        .maincontent .leftspace {
          text-align: left;
          font-size: 14px;
        }
        .maincontent .middlespace {
          text-align: center;
          filter: ${this.goBright ? 'invert(1)' : ''};
        }
        .maincontent .middlespace img {
          transition: all 0.15s;
          height: var(--font-size);
          filter: brightness(0.7);
        }

        .maincontainer:hover .leftspace {
          color: ${this.goBright ? '#000' : '#fff'} ;
        }

        .maincontainer:hover .maincontent .middlespace img {
          filter: brightness(1);
        }
        .maincontent .rightspace {
          position: relative;
        }

        .maincontent .rightspace .buttonContainer {
          transition: all 0.1s;
          position: absolute;
          top: 0px;
          right: 0px;
          text-align: right;
          display: grid;
          grid-template-columns: repeat(7, min-content);
          margin-right: -5px;
        }

        .maincontent .rightspace .buttonContainer lele-materialicon {
          padding: 0px 5px 0px 5px;
          transition: all 0.15s;
          color: ${this.goBright ? '#333' : '#BBB'};
          cursor: pointer;
        }

        .maincontent .rightspace .moreContainer {
          transition: all 0.1s;
          cursor: pointer;
          position: absolute;
          top: 0px;
          right: 0px;
          opacity: 0;
          pointer-events: none;
        }

        .maincontainer:hover .maincontent .rightspace lele-materialicon {
          color: ${this.goBright ? '#000' : '#fff'};
        }
        .maincontainer:hover .maincontent .rightspace lele-materialicon:hover {
          color: #e4002b;
        }

        .extendedInfo {
          display: block;
          overflow: hidden;
          height: 0px;
          transition: height 0.15s ease, background 0.1s;
          background: ${this.goBright ? '#eeeeeb' : '#000000'};
        }

        .extendedInfoScrollContainer {
          overflow-y: scroll;
          height: calc(100vh - 41px);
        }

        .extendedInfo.show {
          height: calc(100vh - 41px);
        }
        .extendedInfo .statusInfo {
          opacity: 0;
          max-width: var(--lelecv-pagewidth, 1200px);
          margin: auto;
          min-height: 150px;
          padding-bottom: 30px;
          transition: opacity 0.3s;
        }
        .extendedInfo .statusInfo.show {
          opacity: 1;
        }

        .extendedInfo .statusInfoHeading {
          text-align: left;
          margin: 20px 0px 10px 0px;
          font-size: 20px;
        }

        .extendedInfo .statusInfo a {
          text-decoration: none;
        }

        .extendedInfo .gridcontainer {
          display: grid;
          grid-template-columns: ${domtools.css.cssGridColumns(6, 15)};
          grid-gap: 15px;
        }

        .extendedInfo .statusInfo .button {
          transition: opacity 0.15s, border-top 0.15s;
          box-sizing: border-box;
          border-radius: 3px;
          background: ${this.goBright ? '#444' : '#222'};
          border: 1px solid ${this.goBright ? '#eeeeeb' : '#222'};
          border-top: 1px solid #444444;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .extendedInfo .statusInfo .button .buttonText {
          text-align: center;
          font-family: 'Roboto Mono', monospace;
          font-size: 12px;
          color:${this.goBright ? '#444' : '#999'};
          background: ${this.goBright ? '#CCC' : '#111'};
          padding: 5px;
        }

        .extendedInfo .statusInfo .button:hover {
          color: #fff;
          border-top: 1px solid #e4002b
        }

        .extendedInfo .statusInfo .button:hover .buttonText {
          color: #fff;
        }


        .extendedInfo .statusInfo .button img {
          transition: all 0.15s;
          filter: grayscale(1);
          width: 100%;
          height: auto;
        }

        .extendedInfo .statusInfo .button:hover img {
          filter: grayscale(0);
        }

        .separator {
          height: 1px;
          max-width: 200px;
          margin-bottom: 20px;
          background-image: linear-gradient(to right, #e4002b , rgba(0,0,0,0));
        }
        
        ${cssManager.cssForTablet(css`
          .maincontent {
            padding-left: 10px;
            padding-right: 10px;
          }
          .extendedInfo {
            padding-left: 10px;
            padding-right: 10px;
          }
          .extendedInfo .gridcontainer {
            display: grid;
            grid-template-columns: ${cssManager.cssGridColumns(6, 15)};
            grid-gap: 15px;
          }
        `)}

        ${cssManager.cssForPhablet(css`
          .maincontent {
            padding-left: 10px;
            padding-right: 10px;
            grid-template-columns: calc(100% - 30px) 0px 30px;
          }
          .maincontent .middlespace {
            opacity: 0;
            pointer-events: none;
            overflow: hidden;
          }
          .maincontent .rightspace .buttonContainer {
            opacity: 0;
            pointer-events: none;
            right: 30px;
          }
          .maincontent .rightspace .moreContainer {
            opacity: 1;
            pointer-events: all;
          }
          .maincontent .leftspace.showButtons {
            opacity: 0;
            pointer-events: none;
          }
          .maincontent .rightspace.showButtons .buttonContainer {
            opacity: 1;
            pointer-events: all;
          }
          .maincontent .rightspace.showButtons .moreContainer {
            opacity: 1;
            pointer-events: all;
          }
          .extendedInfo {
            padding-left: 10px;
            padding-right: 10px;
          }
          .extendedInfo .gridcontainer {
            display: grid;
            grid-template-columns: ${cssManager.cssGridColumns(4, 15)};
            grid-gap: 15px;
          }
        `)}

        ${cssManager.cssForPhone(css`
          .maincontent {
            padding-left: 10px;
            padding-right: 10px;
          }
          .extendedInfo {
            padding-left: 10px;
            padding-right: 10px;
          }
          .extendedInfo .gridcontainer {
            display: grid;
            grid-template-columns: ${cssManager.cssGridColumns(2, 15)};
            grid-gap: 15px;
          }
        `)}
      </style>
      <div class="maincontainer">
        <div class="maincontent">
          <div class="leftspace ${this.showButtons ? 'showButtons' : null}">${this.siteText}</div>
          <div class="middlespace">
            <a href="https://lossless.com" target="_blank"><img src="${this.logoUrl}" /></a>
          </div>
          <div class="rightspace ${this.showButtons ? 'showButtons' : null}">
            <div class="buttonContainer">
              <lele-materialicon
                iconName="brightness_4"
                @click="${async () => {
                  const domtoolsInstance = await this.domtoolsPromise;
                  domtoolsInstance.themeManager.toggleDarkBright();
                }}"
              ></lele-materialicon>
              <lele-materialicon iconName="share"></lele-materialicon>
              <lele-materialicon
                iconName="apps"
                @click="${() => {
                  this.toggleExtendedInfo('products');
                }}"
              ></lele-materialicon>
              <lele-materialicon iconName="textsms"></lele-materialicon>
              <lele-materialicon
                iconName="filter_center_focus"
                @click="${this.runFeedback}"
              ></lele-materialicon>
              <lele-materialicon iconName="notifications"></lele-materialicon>
              <lele-materialicon
                iconName="info"
                @click="${() => {
                  this.toggleExtendedInfo('info');
                }}"
              ></lele-materialicon>
            </div>
            <div class="moreContainer">
              <lele-materialicon
                iconName="${this.showButtons ? 'backspace' : 'more'}"
                @click="${() => {
                  this.showButtons = !this.showButtons;
                }}"
              ></lele-materialicon>
            </div>
          </div>
        </div>
        <div id="extendedInfo" class="extendedInfo">
          <div class="extendedInfoScrollContainer">
            <div class="statusInfo">
              ${this.itemToShow === 'products'
                ? html`
                    ${this.branches.filter(branchArg => {
                      let hasProjects = false;
                      for (const project of this.projects) {
                        if (project.branchSlug === branchArg.slug) {
                          hasProjects = true;
                          return hasProjects;
                        }
                      }
                    }).map(branchArg => html `
                      <div class="statusInfoHeading">${branchArg.name}</div>
                      <div class="separator"></div>
                      <div class="gridcontainer">
                      ${this.projects.filter(projectArg => projectArg.branchSlug === branchArg.slug).map(
                        (project) => html`
                          <div class="button">
                            <a href="${project.url}">
                              <img width="100" height="100" src="${project.logoUrlSquared}" />
                              <div class="buttonText">${project.name}</div>
                            </a>
                          </div>
                        `
                      )}
                      </div>
                    `)}
                  `
                : null}
              ${this.itemToShow === 'info' ? html` <lele-glowstatus></lele-glowstatus> ` : null}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  private async runFeedback(event: MouseEvent) {
    const loadUserBack = async () => {
      const done = domtools.plugins.smartpromise.defer();
      globalThis.Userback = globalThis.Userback || {};
      globalThis.Userback.on_load = () => {
        console.log('Userback loaded!');
        done.resolve();
      };
      globalThis.Userback.access_token =
        '4494|6053|yrlAwcKoIi9hThjEcTmumeT4Vj2MUukIcGGOmhRqUmShgTDoZO';
      const userBackScript = document.createElement('script');
      userBackScript.async = true;
      userBackScript.src = 'https://static.userback.io/widget/v1.js';
      const parentNode = document.head || document.body;
      parentNode.appendChild(userBackScript);
      return done.promise;
    };
    if (!globalThis.Userback) {
      await loadUserBack();
    }
    globalThis.Userback.open('capture');
  }

  private async toggleExtendedInfo(
    itemToShowArg: TItemToShow,
    desiredStateArg?: 'open' | 'closed'
  ) {
    // consolidate args
    if (!desiredStateArg && this.state === 'closed') {
      desiredStateArg = 'open';
    } else if (!desiredStateArg && this.state === 'open' && itemToShowArg === this.itemToShow) {
      desiredStateArg = 'closed';
    } else {
      // when clicking something different we actually want to show that.
      desiredStateArg = 'open';
    }
    const domToolsInstance = await domtools.DomTools.setupDomTools();
    domToolsInstance.scroller.toTop(0);
    const extendedInfo = this.shadowRoot.querySelector('#extendedInfo');
    console.log(`desired state is ${desiredStateArg}`)
    desiredStateArg === 'open'
      ? extendedInfo.classList.add('show')
      : extendedInfo.classList.remove('show');
    switch (itemToShowArg) {
      case 'products':
        // lets do some stugg when viewing projects
        if (extendedInfo.classList.contains('show') && this.projects.length < 1) {
          this.branches = await this.pubapiClient.getBranches();
          this.projects = await this.pubapiClient.getProjects();
        }
        this.itemToShow = 'products';
        break;
      case 'info':
        // lets do some stuff when on info
        this.itemToShow = 'info';
        break;
    }
    const statusInfo = this.shadowRoot.querySelector('.statusInfo');
    if (desiredStateArg === 'open') {
      domToolsInstance.convenience.smartdelay.delayFor(300).then(() => {
        document.body.style.overflow = 'hidden';
        console.log('statusbar disabled body scroll');
      })
      statusInfo.classList.add('show');
    } else {
      document.body.style.overflow = 'auto';
      console.log('statusbar enabled body scroll');
      statusInfo.classList.remove('show');
    }
    this.state = desiredStateArg;
  }
}
